/***
 *
 *   BREADCRUMBS STYLES
 *   Ported from ui-reference/src/components/layouts/breadcrumbs.tsx.
 *
 *   The previous version drew the separator with an `after:content-['_/']`
 *   pseudo-element on a floated link at `text-2xl`. The reference renders the
 *   slash as its own aria-hidden element at `text-sm`, which is what lets the
 *   trail sit inside a 56px top bar.
 *
 **********/

const Style = {
    breadcrumbs: 'flex min-w-0 items-center gap-1.5',

    separator: 'select-none text-sm text-text-muted/50',
    link: 'truncate text-sm text-text-muted transition-colors hover:text-text-primary',
    current: 'truncate text-sm font-medium text-text-secondary',
};

export default Style;
